import { Component, Input, OnInit, inject } from '@angular/core';
import { AffiliationService } from '../../../settings/sections/settings-affiliations/affiliation.service';
import {PersonOrganizationAffiliationDataWrapper} from '../../../shared/interfaces/person-organization-affiliation-data-wrapper.model';
import { DefaultTranslatePipe } from '../../../shared/pipes/default-translate.pipe';


@Component({
    selector: 'esp-overview-affiliation-display',
    templateUrl: './profile-overview-affiliation-display.component.html',
    styleUrls: ['./profile-overview-affiliation-display.component.scss'],
    imports: [DefaultTranslatePipe]
})
export class ProfileOverviewAffiliationDisplayComponent implements OnInit {
    affiliationService = inject(AffiliationService);


    // TODO: Skipped for migration because:
    //  This input is used in a control flow expression (e.g. `@if` or `*ngIf`)
    //  and migrating would break narrowing currently.
    @Input() affiliation: PersonOrganizationAffiliationDataWrapper;

    ngOnInit() {
    }

}
